import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { MutualFundsVenueOrdersTable } from '../../../../../../../../../../features/mutual-funds/venue-order/mutual-funds-venue-orders-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/')(
  {
    staticData: {
      tab: {
        group: TabbedNavigationGroup.ClearingOperationsMutualfunds,
        label: 'Venue Orders',
        order: 1,
      },
    } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsMutualfunds>,
    head: () => getPageHead('Venue Orders'),
    component: FundOrdersList,
  },
);

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsMutualfunds}
    />
  );
}

function FundOrdersList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <MutualFundsVenueOrdersTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
